import { EventsType } from "components/organisms/AddEventModal/types";

export const getEventTypeName = (type: string, typesArray: EventsType[]) => {
  const name = typesArray?.find(
    (eType: EventsType) => eType?.template === type
  )?.name;
  return name ? name : "";
};
